import fetchRequest from '@/app/_utils/fetch-request'
import { selectAPIService } from '@/app/_utils/select-api-service'
import { TimeoutError } from '@/app/_utils/types'

interface Params {
    slug?: string
    isPreview?: boolean
}

export const fetchPageData = async ({ isPreview = false, slug }: Params) => {
    const apiService = selectAPIService()

    try {
        const data = await fetchRequest({
            endpoint: slug ? `/pages?slug=${slug}&preview=${isPreview}` : '/pages',
            method: 'GET',
            serviceName: apiService.cml,
        })

        return data
    } catch (error) {
        if (error instanceof TimeoutError) {
            throw error
        }
        return null
    }
}
